var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83564 18.3788C6.83564 16.9926 7.96321 15.8651 9.34934 15.8651H33.6891L30.8091 6.74752C30.5398 5.90005 29.6313 5.42604 28.7802 5.69536L4.12803 13.4878C3.27696 13.7572 2.80654 14.6657 3.07587 15.5167L6.83923 27.4173V18.3788H6.83564Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91284 32.9438C7.91284 33.7374 8.55563 34.3802 9.34924 34.3802H35.5635C36.3571 34.3802 36.9999 33.7374 36.9999 32.9438V31.0047H7.91284V32.9438Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9999 18.3788C36.9999 17.5852 36.3571 16.9424 35.5635 16.9424H34.0302H9.34924C8.55563 16.9424 7.91284 17.5852 7.91284 18.3788V28.3079H15.0841H36.9999V18.3788Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.65e6622b3db6384f24a2ca1f185d7efe704dcd84a3a7ec1d89d8c40a11af7bef.svg";
export { ForwardRef as ReactComponent };